import React from "react";

import {
  SearchResultsProductCardOutputProps,
  withSearchResultsProductCard,
} from "./withSearchResultsProductCard";

import { ProductCard } from "@components/ProductCard";

export const SearchResultsProductCard = ({
  product,
  productGroup,
  pagePosition,
}: SearchResultsProductCardOutputProps) => {
  return (
    <article data-testid="search-result-product-card" className="mb-midi">
      <ProductCard {...product} index={pagePosition - 1} sizes="33vw" />

      <div
        className="ruk_rating_snippet ruk_rating_snippet--clp empty:mb-0 mb-pico block px-micro"
        data-sku={productGroup}
      />
    </article>
  );
};

export default withSearchResultsProductCard(SearchResultsProductCard);
